/* eslint-disable @typescript-eslint/no-explicit-any */
import { initialData } from "@/assets/demmyData/demmyData";
import BootstrapInput from "@/components/BootstrapInput";
import MultiLevelDropdown from "@/components/MultiLevelDropdown";
import NotificationComponent from "@/components/NotificationComponent";
import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";

function MyVerticallyCenteredModal(props: any) {
  const [category, setCategory] = useState<string>("");

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

  };

  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" backdrop="static"
      keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Modal heading
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <BootstrapInput
            value={category}
            setValue={setCategory}
            placeholder="Enter Category"
            label="Enter Category"
          />

          <MultiLevelDropdown data={[]} />

          <Button type="submit" className="mt-4">
            Submit
          </Button>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}

function AddCategory() {
  const [modalShow, setModalShow] = useState(false);

  return (
    <div>
      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
      <div className="add-category">
        <div>
          <Button variant="primary" onClick={() => setModalShow(true)}>
            Create Category
          </Button>
        </div>
      </div>

      <div className="mt-4">
        <NotificationComponent
          data={initialData}
          heading="ALL CATEGORY INFORMATION"
        />
      </div>
    </div>
  );
}

export default AddCategory;
